<template lang="pug">
div
  //- el-form-item(:label="$t('equivalenceorcorrespondence')")
  //-     | {{isConsideration}} {{isCorrespondence}}
  //- el-tooltip(placement='right')
    div(slot='content')
      | {{ $t("hint_correspondence_uni") }}
    i.el-icon-question
  div()
    div(v-if="application.titlesCorrespondence.universityDepartment")
      el-form-item(:label="$t('department')", prop="titlesCorrespondence.universityDepartment.name",
        v-if="application.recognitionWith === 'aei' || application.recognitionWith === 'aeiAndTei' || application.recognitionWith === 'tei'")
        el-autocomplete(popper-class='my-autocomplete', v-model='correspondenceAEI',
          :fetch-suggestions='querySearchAEI', :placeholder="$t('search')", @select='handleSelectAEI')
          template(slot-scope='{ item }')
            .value {{ item.institution_name }}
            span.link {{ item.department_name }} ({{item.department_id}})
            hr
        i(class="el-icon-error" @click="deleteAEI")
        div {{correspondenceAEI}}
    //- div(v-if="application.titlesCorrespondence.TEIDepartment")
      el-form-item(:label="$t('department2')", prop="titlesCorrespondence.TEIDepartment.name",
      v-show="application.recognitionWith === 'tei' || application.recognitionWith === 'aeiAndTei'")
        el-autocomplete(popper-class='my-autocomplete', v-model='correspondenceTEI',
          :fetch-suggestions='querySearchTEI', :placeholder="$t('search')", @select='handleSelectTEI')
          template(slot-scope='{ item }')
            .value {{ item.institution_name }}
            span.link {{ item.department_name }} ({{item.department_id}})
            hr
        i(class="el-icon-error" @click="deleteTEI")
        div {{correspondenceTEI}}
</template>

<script>
export default {
  props: ['application', 'allDepartments'],
  // props: ['application', 'greekUniversityDepartments', 'greekTeiDepartments'],
  mounted() {
    if (
      this.application.titlesCorrespondence &&
      this.application.titlesCorrespondence.universityDepartment.name !== null
    ) {
      this.correspondenceAEI = this.application.titlesCorrespondence.universityDepartment.name
    }
    if (
      this.application.titlesCorrespondence &&
      this.application.titlesCorrespondence.TEIDepartment.name !== null
    ) {
      this.correspondenceTEI = this.application.titlesCorrespondence.TEIDepartment.name
    }
  },
  data() {
    return {
      correspondenceAEI: '',
      correspondenceTEI: '',
    }
  },
  computed: {
    isCorrespondence() {
      // if (this.application.correspondence) {
      //   return this.$t('with_equivalence')
      // } else return this.$t('without_equivalence')
      // if (this.application.recognitionWith === 'aeiAndTei') {
      //   return this.$t('with') + '' + this.$t('uni_tei')
      // } else if (this.application.recognitionWith === 'aei') {
      //   return this.$t('only') + this.$t('university')
      // } else {
      //   return this.$t('only') + this.$t('tei')
      // }
    },
    isConsideration() {
      return this.application.consideration
        ? this.$t(' with_consideration')
        : this.$t(' without_consideration')
    },
  },
  methods: {
    deleteAEI() {
      this.correspondenceAEI = ''
      this.application.titlesCorrespondence.universityDepartment.name = this.correspondenceAEI
      this.application.titlesCorrespondence.universityDepartment.id = null
      this.$emit(
        'titlesCorrespondenceChanged',
        this.application.titlesCorrespondence
      )
    },
    deleteTEI() {
      this.correspondenceTEI = ''
      this.application.titlesCorrespondence.TEIDepartment.name = this.correspondenceTEI
      this.application.titlesCorrespondence.TEIDepartment.id = null
      this.$emit(
        'titlesCorrespondenceChanged',
        this.application.titlesCorrespondence
      )
    },
    handleSelectAEI(item) {
      this.correspondenceAEI = `${item.department_name} (${item.department_id}) - ${item.institution_name}`
      this.application.titlesCorrespondence.universityDepartment.name = this.allDepartments.find(
        dep => dep.department_id === item.department_id
      ).department_name
      this.application.titlesCorrespondence.universityDepartment.id =
        item.department_id
      this.formValidation ? this.checkForm() : console.log('AEI selected')
      this.$emit(
        'titlesCorrespondenceChanged',
        this.application.titlesCorrespondence
      )
    },
    handleSelectTEI(item) {
      this.correspondenceTEI = `${item.department_name} (${item.department_id}) - ${item.institution_name}`
      this.application.titlesCorrespondence.TEIDepartment.name = this.greekTeiDepartments.find(
        dep => dep.department_id === item.department_id
      ).department_name
      this.application.titlesCorrespondence.TEIDepartment.id = item.department_id
      this.formValidation ? this.checkForm() : console.log('TEI selected')
      this.$emit(
        'titlesCorrespondenceChanged',
        this.application.titlesCorrespondence
      )
    },
    // querySearchAEI(queryString, cb) {
    //   var results =
    //     this.allDepartments && queryString !== null
    //       ? this.allDepartments.filter(
    //           this.createFilter(queryString)
    //         )
    //       : this.allDepartments
    //   cb(results)
    // },
    //
    // The new search will find and return departments that contain 
    // all the tokens (words) in any order and position
    // in its name, id and university.
    querySearchAEI(queryString, cb) {
      if (queryString) {
        const tokens = queryString.toLowerCase().split(/\s+/)
        const results = this.allDepartments.filter(university => {
          const lowerCasedDepartment = university.department_name.toLowerCase() +
            ' (' + university.department_id + ') ' +
            university.institution_name.toLowerCase()
          return tokens.every(token => lowerCasedDepartment.includes(token))
        })
        cb(results)
      } else {
        cb(this.allDepartments)
      }
    },
    querySearchTEI(queryString, cb) {
      var results =
        this.greekTeiDepartments && queryString !== null
          ? this.greekTeiDepartments.filter(this.createFilter(queryString))
          : this.greekTeiDepartments
      // call callback function to return suggestion objects
      cb(results)
    },
    createFilter(queryString) {
      return link => {
        return (
          link.department_name
            .toLowerCase()
            .includes(queryString.toLowerCase())
            // .indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
  },
  watch: {
    application: {
      handler: function(newVal, oldVal) {
        this.correspondenceAEI =
          newVal.titlesCorrespondence.universityDepartment.name
        this.correspondenceTEI = newVal.titlesCorrespondence.TEIDepartment.name
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.el-autocomplete {
  width: 440px;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 3px;

    .value {
      text-overflow: clip;
      font-size: 9px;
      overflow: hidden;
      color: #6d728b;
      white-space: normal;
    }
    .link {
      text-overflow: clip;
      font-size: 10px;
      color: #33408a;
      white-space: normal;
    }
  }
}
</style>
